<template>
  <div class="contest-layout portal-home-font-2x bg-surface font-body text-on-surface min-h-screen">
    <header class="fixed top-0 w-full z-50 glass-header shadow-sm bg-white/90 backdrop-blur-md portal-home-header-2x">
      <div class="portal-shrink-header-shell flex justify-between items-center w-full px-8 py-4 max-w-[1440px] mx-auto flex-wrap gap-4">
        <div class="flex items-center gap-2 md:gap-4 lg:gap-8 flex-wrap">
          <div class="text-3xl font-bold tracking-tight text-primary font-headline">人人都是创新官</div>
          <nav class="portal-shrink-nav flex items-center gap-2 md:gap-4 lg:gap-6 flex-wrap">
            <router-link to="/contest/home" class="nav-link text-slate-600 hover:text-secondary text-lg font-semibold transition-colors duration-200" active-class="text-primary font-bold border-b-2 border-secondary pb-1">首页</router-link>
            <button class="contest-header-action text-slate-600 hover:text-secondary text-lg font-semibold transition-colors duration-200" @click="goHomeSection('intro')">活动介绍</button>
            <button class="contest-header-action text-slate-600 hover:text-secondary text-lg font-semibold transition-colors duration-200" @click="goHomeSection('rules')">活动规则</button>
            <button class="contest-header-action text-slate-600 hover:text-secondary text-lg font-semibold transition-colors duration-200" @click="goHomeSection('schedule')">时间安排</button>
            <button class="contest-header-action text-slate-600 hover:text-secondary text-lg font-semibold transition-colors duration-200" @click="goHomeSection('guide')">小程序参与</button>
          </nav>
        </div>
        <div class="flex items-center gap-4 flex-wrap justify-end">
          <nav class="portal-shrink-action-row flex items-center gap-2 md:gap-4 lg:gap-6 flex-wrap">
            <div class="w-px h-6 bg-surface-container-high mx-2 hidden md:block"></div>
            <button class="portal-shrink-action-button contest-header-action bg-primary text-on-primary px-4 py-2 rounded-lg text-lg font-semibold hover:opacity-90 transition-all" @click="goPortal">返回首页</button>
          </nav>
        </div>
      </div>
    </header>
    <main class="pt-20">
      <router-view></router-view>
    </main>
  </div>
</template>

<script>
export default {
  name: 'ContestLayout',
  methods: {
    goPortal() {
      this.$router.push('/')
    },
    goHomeSection(section) {
      if (this.$route.path !== '/contest/home' || this.$route.query.section !== section) {
        this.$router.push({
          path: '/contest/home',
          query: { section: section }
        })
        return
      }
      this.$nextTick(() => {
        const el = document.getElementById(section)
        if (el) {
          el.scrollIntoView({ behavior: 'smooth', block: 'start' })
        }
      })
    }
  }
}
</script>

<style scoped>
.nav-link {
  text-decoration: none;
  outline: none !important;
  box-shadow: none !important;
  -webkit-tap-highlight-color: transparent;
}

.nav-link:focus,
.nav-link:active,
.contest-header-action:focus,
.contest-header-action:active {
  outline: none !important;
  box-shadow: none !important;
}

.nav-link:focus-visible,
.contest-header-action:focus-visible {
  outline: 2px solid rgba(197, 160, 89, 0.45) !important;
  outline-offset: 4px;
  border-radius: 6px;
}
</style>



// WEBPACK FOOTER //
// src/contest/views/ContestLayout.vue